import { CrtData } from './data';
import { EcartStatus } from './lr';

/**
 * Donnée CRT augmenté avec les champs propre aux lois de régulation
 */
export interface CrtDataLr extends CrtData {
  /**
   *  Type de la donnée (MIN/MAX/X/Y/...)
   */
  typeDonnee: DonneeLrType;

  /**
   * Numéro de la donnée (pour les X, les Y et les réduits)
   */
  numeroDonnee: number;

  /**
   * Statut de l'écart avec les valeurs conseillées
   */
  ecartStatus?: EcartStatus;
}

/**
 * Type de donnée d'une lois
 */
export enum DonneeLrType {
  /**
   * Min
   */
  MIN = 'MIN',
  /**
   * MAX
   */
  MAX = 'MAX',
  /**
   * X
   */
  X = 'X',
  /**
   * Y
   */
  Y = 'Y',
  /**
   * Réduit
   */
  R = 'R',
  /**
   * Pour les données simple
   */
  SIMPLE = 'SIMPLE',
}
